/**
 * HTTP layer for scheduled unit commands. The future-dated commands queued to
 * run against a site's hardware.
 *
 * Contains:
 * - fetchCommandSchedules / fetchCommandSchedule: schedule reads
 * - postCommandSchedule / patchCommandSchedule / deleteCommandSchedule: schedule writes
 */
import apiClient from '../http-common';

const SCHEDULED_COMMANDS_ENDPOINT = '/command-schedules';

export const fetchCommandSchedules = queryParams =>
  apiClient.get(`${SCHEDULED_COMMANDS_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchCommandSchedule = id => apiClient.get(`${SCHEDULED_COMMANDS_ENDPOINT}/${id}/`).then(res => res.data);

export const postCommandSchedule = data =>
  apiClient.post(`${SCHEDULED_COMMANDS_ENDPOINT}/`, data).then(res => res.data);

export const patchCommandSchedule = (id, data) =>
  apiClient.patch(`${SCHEDULED_COMMANDS_ENDPOINT}/${id}/`, data).then(res => res.data);

export const deleteCommandSchedule = id => apiClient.delete(`${SCHEDULED_COMMANDS_ENDPOINT}/${id}/`);
